import type { ReactNode } from "react";
import styled from "styled-components";
import { ChartCardPanel } from "./ChartCardPanel";
import { RANKING_FONT } from "./rankingTheme";

const Panel = styled(ChartCardPanel)`
	height: 100%; display: flex; flex-direction: column; container-type: inline-size;
	.header-actions { display: flex; flex-shrink: 0; align-items: center; gap: 8px; }
	.body { display: flex; flex: 1; flex-direction: column; gap: 10px; font: 13px/1.45 ${RANKING_FONT}; }
	.currency { flex-shrink: 0; padding: 3px 7px; border: 1px solid #e1e6ef; border-radius: 5px; color: #667085; font: 11px/1.4 ${RANKING_FONT}; }
	.metric { margin: 0; font-size: 28px; font-weight: 600; line-height: 1.2; letter-spacing: -0.6px; color: #1d2939; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }
	.caption { margin: 0; color: #667085; font-size: 12px; line-height: 1.5; }
	.amount { margin: auto 0; }
	.amount .caption { margin-top: 6px; }
	.conversion { display: flex; flex: 1; flex-direction: column; justify-content: center; gap: 20px; padding: 10px 0; }
	.conversion .metric { font-size: 44px; color: #167ca6; }
	.conversion .caption { margin-top: 6px; }
	.conversion-circular { align-items: center; gap: 8px; padding: 0; text-align: center; }
	.conversion-circular .caption { margin-top: 0; }
	.conversion-ring { position: relative; width: 160px; max-width: 100%; aspect-ratio: 1; }
	.conversion-ring svg { display: block; width: 100%; height: 100%; }
	.conversion-ring .metric { position: absolute; inset: 22px; display: flex; align-items: center; justify-content: center; font-size: 44px; }
	.conversion-value { display: inline-flex; align-items: baseline; }
	.conversion-value small { font-size: 0.5em; letter-spacing: 0; }
	.conversion-progress { transition: stroke-dasharray 240ms ease-out; }
	@media (prefers-reduced-motion: reduce) { .conversion-progress { transition: none; } }
	.track { display: flex; height: 8px; border-radius: 4px; overflow: hidden; background: #eef1f5; }
	.segment { height: 100%; flex-shrink: 0; }
	.scale { display: flex; justify-content: space-between; margin-top: 6px; color: #98a2b3; font-size: 11px; font-variant-numeric: tabular-nums; }
	.breakdown { display: grid; grid-template-columns: minmax(0, 1fr) max-content max-content; gap: 0 12px; margin: 0; }
	.breakdown > div { display: grid; grid-template-columns: subgrid; grid-column: 1 / -1; align-items: baseline; padding: 8px 0; border-bottom: 1px solid #edf0f5; }
	.breakdown > div:last-child { border-bottom: 0; }
	.breakdown dt { display: flex; align-items: center; gap: 7px; min-width: 0; color: #667085; overflow-wrap: anywhere; }
	.dot { width: 7px; height: 7px; flex-shrink: 0; border-radius: 2px; }
	.breakdown dd { margin: 0; text-align: right; font-variant-numeric: tabular-nums; }
	.count { font-size: 15px; font-weight: 600; }
	.share { color: #667085; font-size: 12px; }
	.footnote { margin-top: auto; padding-top: 4px; }
	@container (max-width: 260px) {
		.metric { font-size: 24px; }
		.breakdown { grid-template-columns: minmax(0, 1fr) max-content; column-gap: 8px; }
		.breakdown .share { grid-column: 2; }
	}
`;

export const SummaryCard = ({ title, icon, prefix, actions, children }: { title: string; icon: ReactNode; prefix?: string; actions?: ReactNode; children: ReactNode }) => <Panel aria-label={title}>
	<div className="header"><h3>{icon}<span>{title}</span></h3>{(prefix || actions) && <div className="header-actions">{prefix && <span className="currency">{prefix}</span>}{actions}</div>}</div>
	<div className="body">{children}</div>
</Panel>;
